import { FILTERS, DOCUMENT_SCORECARD } from '@Constants/types';
import { scorecardsWithValidClauses } from '@Utils/jsonUtils';

const scorecardsMiddleware = ({ dispatch, getState }) => next => action => {
    const tempRiskMap = {};
    const sortedRiskMap = {};
    let tempSortFlags = {};
    let topicsList = {};
    let subtopicList = {};
    let captureTheHighestSeverityValue = 1;

    switch (action.type) {
        case DOCUMENT_SCORECARD.FETCH_SCORECARD_SUCCESS:
            const { payload: scorecard } = action;
            const { SortFlagsInput } = getState().scoreCardFilters;
            const { flattenClauseGroups } = getState().clause;

            if (scorecard && scorecard.data && scorecard.data.riskMap) {
                const { scoreCardElementList } = scorecard.data;
                const sortingTempList = [...scoreCardElementList];

                Object.keys(scorecard.data.riskMap).map(key => {
                    // utlize the severity as an index for sorting maps elements
                    const keyGen = scorecard.data.riskMap[key].severity;
                    tempRiskMap[keyGen] = {
                        ...scorecard.data.riskMap[key],
                        text: key,
                        selected: true
                    };
                    captureTheHighestSeverityValue =
                        captureTheHighestSeverityValue < keyGen
                            ? keyGen
                            : captureTheHighestSeverityValue;

                    return null;
                });

                Object.keys(tempRiskMap).map(key => {
                    sortedRiskMap[tempRiskMap[key].text] = {
                        ...tempRiskMap[key]
                    };

                    return null;
                });
                dispatch({ type: FILTERS.SET_RISK_LEVELS, payload: sortedRiskMap });

                // Make sure sorting by risk levels is dynamic to input
                tempSortFlags = { ...SortFlagsInput };
                if (tempRiskMap[1] && tempRiskMap[1].text) {
                    tempSortFlags.RiskHL.text = `Risk (${[tempRiskMap[1].text]} - ${[
                        tempRiskMap[captureTheHighestSeverityValue].text
                    ]})`;
                    tempSortFlags.RiskLH.text = `Risk (${[
                        tempRiskMap[captureTheHighestSeverityValue].text
                    ]} - ${[tempRiskMap[1].text]})`;
                }
                dispatch({ type: FILTERS.SET_SORTING, payload: tempSortFlags });

                sortingTempList.sort((a, b) => a.topic.localeCompare(b.topic)).forEach(element => {
                    topicsList[element.topic] = {
                        text: element.topic,
                        selected: false
                    };
                });
                dispatch({ type: FILTERS.SET_TOPICS, payload: topicsList });

                sortingTempList
                    .sort((a, b) => a.subtopic.localeCompare(b.subtopic))
                    .forEach(element => {
                        subtopicList[element.subtopic] = {
                            text: element.subtopic,
                            selected: false
                        };
                    });
                dispatch({ type: FILTERS.SET_SUBTOPICS, payload: subtopicList });

                dispatch({
                    type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_REQUEST
                });
                if (flattenClauseGroups) {
                    dispatch({
                        type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_SUCCESS,
                        payload: {
                            data: {
                                ...scorecard.data,
                                scoreCardElementList: scorecardsWithValidClauses(
                                    scorecard.data.scoreCardElementList,
                                    flattenClauseGroups
                                )
                            }
                        }
                    });
                } else {
                    dispatch({
                        type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_FAILURE,
                        payload: 'Clauses are not fetched yet'
                    });
                }
            }
            return next(action);

        case FILTERS.RESET_FILTERS:
            const {
                SortFlagsInput: sortFlags,
                topicFlagsInput,
                subTopicFlagsInput,
                riskFlagsInput
            } = getState().scoreCardFilters;

            Object.keys(riskFlagsInput).forEach(key => {
                tempRiskMap[key] = { ...riskFlagsInput[key] };
                tempRiskMap[key].selected = true;
            });
            dispatch({ type: FILTERS.SET_RISK_LEVELS, payload: tempRiskMap });

            subtopicList = {};
            // assigning subtopicList = {} adding extra step added
            // to use spread Operator to preserve immutability ;
            Object.keys(subTopicFlagsInput).forEach(key => {
                subtopicList[key] = { ...subTopicFlagsInput[key] };
                subtopicList[key].selected = false;
            });
            dispatch({ type: FILTERS.SET_SUBTOPICS, payload: subtopicList });

            topicsList = {};
            Object.keys(topicFlagsInput).forEach(key => {
                topicsList[key] = { ...topicFlagsInput[key] };
                topicsList[key].selected = false;
            });
            dispatch({ type: FILTERS.SET_TOPICS, payload: topicsList });

            tempSortFlags = {};
            Object.keys(sortFlags).forEach(key => {
                tempSortFlags[key] = { ...sortFlags[key] };
                tempSortFlags[key].selected = key === 'RiskHL';
            });
            dispatch({ type: FILTERS.SET_SORTING, payload: tempSortFlags });

            return next(action);
        default:
            return next(action);
    }
};

export default scorecardsMiddleware;
